import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AUTH_LOGIN_ROUTE } from './auth-login-route.token';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const loginRoute = inject(AUTH_LOGIN_ROUTE);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(loginRoute, { queryParams: { returnUrl: state.url } });
};
